import { PasswordChangeBody, userApis } from '@apis/userApis';
import { useMutation } from '@hooks/useMutation';
import { useQueryClient } from '@tanstack/react-query';
import { FormError } from '@utils/errors';

export const usePatchPassword = () => {
  const queryClient = useQueryClient();

  return useMutation(
    async (body: PasswordChangeBody) => {
      const response = await userApis.post('/password/change/', { body });
      if (response[400]) {
        throw new FormError('PatchPasswordError', response[400]);
      }
      return response[200]!;
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries(['/user/']);
        queryClient.invalidateQueries(['/company/']);
      },
    },
  );
};
